"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$figStruct = exports.$fig = exports.figStructToLines = exports.figToLines = exports.figStructControl = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const error_1 = require("../../cst/error");
const inline_1 = require("../../../node/cst/inline");
const el_1 = require("../../../node/el");
const util_2 = require("../../../util");
const _remarks_1 = __importStar(require("./$remarks"));
const _sentencesArray_1 = require("../../cst/rules/$sentencesArray");
exports.figStructControl = ":fig-struct:";
/**
 * The renderer for {@link std.Fig}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$figStruct.spec.ts) for examples.
 */
const figToLines = (fig, indentTexts) => {
    const lines = [];
    lines.push(new line_1.OtherLine({
        range: null,
        indentTexts,
        controls: [],
        sentencesArray: [
            new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, [new el_1.EL("__CapturedXML", {}, [fig])])]),
        ],
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    return lines;
};
exports.figToLines = figToLines;
/**
 * The renderer for {@link std.FigStruct}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$figStruct.spec.ts) for examples.
 */
const figStructToLines = (figStruct, indentTexts) => {
    const lines = [];
    const figStructTitleSentenceChildren = figStruct.children.find(el => el.tag === "FigStructTitle")?.children;
    const requireControl = Boolean(figStructTitleSentenceChildren) || figStruct.children.length !== 1 || figStruct.children[0].tag !== "Fig";
    if (requireControl) {
        lines.push(new line_1.OtherLine({
            range: null,
            indentTexts,
            controls: [
                new inline_1.Control(exports.figStructControl, null, "", null)
            ],
            sentencesArray: figStructTitleSentenceChildren ? [
                new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, figStructTitleSentenceChildren)])
            ] : [],
            lineEndText: toCSTSettings_1.default.EOL,
        }));
    }
    const childrenIndentTexts = requireControl ? [...indentTexts, toCSTSettings_1.default.INDENT] : indentTexts;
    for (const child of figStruct.children) {
        if (child.tag === "FigStructTitle")
            continue;
        if (child.tag === "Fig") {
            lines.push(...(0, exports.figToLines)(child, childrenIndentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else if (child.tag === "Remarks") {
            lines.push(...(0, _remarks_1.remarksToLines)(child, childrenIndentTexts));
            lines.push(new line_1.BlankLine({ range: null, lineEndText: toCSTSettings_1.default.EOL }));
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    return lines;
};
exports.figStructToLines = figStructToLines;
/**
 * The parser rule for {@link std.Fig}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$figStruct.spec.ts) for examples.
 */
exports.$fig = factory_1.factory
    .withName("fig")
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.type === line_1.LineType.OTH
        && item.line.sentencesArray.length === 1
        && item.line.sentencesArray[0].sentences.length === 1
        && item.line.sentencesArray[0].sentences[0].children.length === 1
        && typeof item.line.sentencesArray[0].sentences[0].children[0] !== "string"
        && item.line.sentencesArray[0].sentences[0].children[0].tag === "__CapturedXML"
        && item.line.sentencesArray[0].sentences[0].children[0].children.length === 1
        && typeof item.line.sentencesArray[0].sentences[0].children[0].children[0] !== "string"
        && (0, std_1.isFig)(item.line.sentencesArray[0].sentences[0].children[0].children[0])) {
        const errors = [];
        const fig = item.line.sentencesArray[0].sentences[0].children[0].children[0].copy(false);
        if (!("src" in fig.attr)) {
            errors.push(new error_1.ErrorMessage("$figStruct: Figタグ に src 属性が設定されていません。", item.virtualRange));
            fig.attr.src = "";
        }
        return {
            value: fig,
            errors,
        };
    }
    else {
        return null;
    }
});
const $figStructChildrenBlock = (0, util_1.makeIndentBlockWithCaptureRule)("$figStructChildrenBlock", (factory_1.factory
    .choice(c => c
    .or(() => exports.$fig)
    .or(() => _remarks_1.default))));
/**
 * The parser rule for {@link std.FigStruct}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$figStruct.spec.ts) for examples.
 */
exports.$figStruct = factory_1.factory
    .withName("figStruct")
    .choice(c => c
    .orSequence(s => s
    .and(() => exports.$fig, "fig")
    .action(({ fig }) => {
    const figStruct = (0, std_1.newStdEL)("FigStruct", {}, [fig.value]);
    figStruct.range = (0, el_1.rangeOfELs)(figStruct.children);
    return {
        value: figStruct,
        errors: fig.errors,
    };
}))
    .orSequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.OTH
        && item.line.controls.some(c => c.control === exports.figStructControl)) {
        return item;
    }
    else {
        return null;
    }
}), "titleLine")
    .and(r => r.zeroOrMore(() => util_1.$blankLine))
    .and(r => r
    .zeroOrOne(() => $figStructChildrenBlock), "childrenBlock")
    .action(({ titleLine, childrenBlock }) => {
    const children = [];
    const errors = [];
    const figStructTitleSentenceChildren = (0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(titleLine.line.sentencesArray);
    const figStructTitle = figStructTitleSentenceChildren.length > 0 ? (0, std_1.newStdEL)("FigStructTitle", {}, figStructTitleSentenceChildren, titleLine.line.sentencesArrayRange) : null;
    if (figStructTitle) {
        children.push(figStructTitle);
    }
    if (childrenBlock) {
        children.push(...childrenBlock.value.flat().map(v => v.value).flat());
        errors.push(...childrenBlock.value.flat().map(v => v.errors).flat());
        errors.push(...childrenBlock.errors);
    }
    const pos = titleLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    const figStruct = (0, std_1.newStdEL)("FigStruct", {}, children, range);
    return {
        value: figStruct,
        errors,
    };
})));
exports.default = exports.$figStruct;
//# sourceMappingURL=$figStruct.js.map